import React, { useEffect, useState, useContext, useCallback, Fragment } from 'react';
import { connect } from 'react-redux';
import config from '../../../../config';
import { resetState } from '../../../../actionCreators/success';
import { getPendingStatus } from '../../../../CommonComponents/OrderStatus/utils';
import ItemHeader from '../../../../CommonComponents/OrderStatus/ItemHeader';
import Status from '../../../../CommonComponents/OrderStatus/Status';
import ReOrder from '../../../../CommonComponents/ReOrder/ReOrder';
import AddPower from '../../../../CommonComponents/OrderStatus/AddPower';
import UpdatePower from './UpdatePower';
import PowerDetails from '../../../../CommonComponents/PowerDetails/PowerDetails';
import { OrderContext } from './OrderListing';
import { OrderDetailContext } from './OrderDetail';
import TrackingTimeline from './TrackingTimeline';
import PendingStatus from '../../../../CommonComponents/OrderStatus/PendingStatus';
import LKModal from '../../Modal/Modal';
import DelayReason from '../../../../CommonComponents/OrderStatus/DelayReason';
import './Items.scss';
import AddPdText from '../../../../CommonComponents/OrderStatus/AddPdText';
import SuccessModalHeader from '../../Success/SuccessModalHeader';
import AddPD from '../../../components/Success/AddPD';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import { getOrders } from '../../../../actionCreators/myAccount';
import { getOrder } from '../../../../actionCreators/order';

function filterTrackingStatus(item, EARLY) {
  const {
    statusHistory = [],
    itemTracking: { courierTrackingUrl, statusLabel, histories = [] } = {},
  } = item;
  let currentStatus;
  let hasDelivered;
  let statusObj;
  let arrivedEarlyText = '';
  const historiesLen = histories.length;
  if (historiesLen) {
    for (let i = 0; i < historiesLen; i++) {
      statusObj = histories[i];
      const { status, current, createdAt, isEarly } = statusObj;
      if (['DELIVERED_AT_STORE', 'DELIVERED_TO_CUSTOMER'].includes(status) && createdAt) {
        hasDelivered = true;
      }
      if (current) {
        if (isEarly) {
          arrivedEarlyText = EARLY;
        }
        currentStatus = statusObj;
        break;
      }
    }
  } else {
    hasDelivered = statusHistory.some(history => history.status === 'DELIVERED');
    currentStatus = { statusLabel, courierTrackingUrl };
  }
  return { currentStatus, hasDelivered, arrivedEarlyText };
}

function Item(props) {
  const {
    localeInfo,
    resetState,
    currencyMark,
    listing,
    history,
    orderData,
    redisCommonData,
    orderData: {
      id: orderId,
      createdAt,
      payments: { paymentList = [] },
    },
    item,
    item: {
      id,
      itemTracking,
      eligibleForReorder,
      deliveryDate,
      powerRequired,
      prescriptionView,
      delayReason,
      revisedEta,
      flags: { canUpdatePrescription, showTrackingHistory } = {},
      classification,
      productId,
      returnId,
    },
    pendingOrderStatus,
    dataLocale,
    returnEligibilityItemDetails,
    returnConfig,
    userInfoForPd,
    getOrder,
    getOrders,
  } = props;
  const [trackingStatus, setStatus] = useState({});
  const [pendingStatus, setPendingStatus] = useState({});
  const [showItemExchangeRefund, showItemExchangeRefundFn] = useState(false);
  const [isReturnCancelled, setIsReturnCancelled] = useState(false);
  const [showPowerOptions, setPowerOptions] = useState(false);
  const [showPower, showPowerDetails] = useState(true);
  const [isOnlyPd, setSheet] = useState(false);

  const { userInfo, orderStatusRedis, match } =
    useContext(listing ? OrderContext : OrderDetailContext) || {};
  const [showPrescription, showUploadedPresc] = useState(false);
  const showUploadPrescModal = useCallback(() => {
    showUploadedPresc(!showPrescription);
  }, [showPrescription]);
  const showPowerOptionsFn = useCallback(() => {
    resetState();
    setPowerOptions(!showPowerOptions);
  }, [showPowerOptions]);
  const showPowerDetailsFn = useCallback(section => {
    if (
      ['CONTACT_FOR_POWER', 'POWER_UPLOAD'].includes(section) &&
      itemTracking?.status === 'CANCELLED'
    )
      showPowerDetails(false);
  }, []);
  useEffect(() => {
    if (returnConfig && returnConfig.enableNewFlow && returnEligibilityItemDetails) {
      showItemExchangeRefundFn(true);
      if (itemTracking?.status === 'RETURN_CANCELLED') {
        setIsReturnCancelled(true);
      }
    }
  }, [returnEligibilityItemDetails]);
  useEffect(() => {
    const isSeamless = paymentList.some(payment => payment.method === 'sm');
    if (itemTracking?.status === 'ORDER_PLACED')
      setPendingStatus(
        getPendingStatus(pendingOrderStatus, powerRequired, dataLocale, createdAt, isSeamless)
      );
    setStatus(filterTrackingStatus(item, dataLocale?.EARLY));
  }, [pendingOrderStatus, powerRequired]);

  useEffect(() => {
    if (isOnlyPd) {
      document.body.classList.add('no-scroll-account');
      document.getElementsByTagName('html')[0].classList.add('no-scroll-account');
    } else {
      document.body.classList.remove('no-scroll-account');
      document.getElementsByTagName('html')[0].classList.remove('no-scroll-account');
    }
  }, [isOnlyPd]);
  const { hasDelivered, currentStatus = {}, arrivedEarlyText } = trackingStatus;
  function updateOrder(getOrders, showPowerOptionsFn, match, getOrder) {
    const pageNumber = sessionStorageHelper.getItem('orderActivePage') || 0;
    const pager = pageNumber <= 1 ? 0 : pageNumber - 1;
    getOrders(pager, 10);
    if (match?.params?.id) {
      getOrder({ orderId: match.params.id, dontInitSession: true, isMyAcct: true });
    }
    if (showPowerOptions) showPowerOptionsFn();
  }
  return (
    <div className="item margin-t5 margin-b5 padding-b5 bg-color-white" data-testid="orderItem">
      {Object.keys(pendingStatus).length > 0
        ? !orderData?.isInsuranceFlow && (
            <PendingStatus createdAt={createdAt} pendingStatus={pendingStatus} view="desktop" />
          )
        : currentStatus.statusLabel && (
            <Status
              arrivedEarlyText={arrivedEarlyText}
              dataLocale={dataLocale}
              delayReason={delayReason}
              delivered={hasDelivered}
              deliveryDate={!hasDelivered && deliveryDate}
              itemTracking={itemTracking}
              localeInfo={localeInfo}
              orderData={orderData}
              revisedEta={revisedEta}
              status={currentStatus}
              view="desktop"
            />
          )}
      {delayReason && revisedEta && (
        <DelayReason
          dataLocale={dataLocale}
          delayReason={delayReason}
          revisedEta={revisedEta}
          view="desktop"
        />
      )}
      <ItemHeader
        classification={classification}
        currencyMark={currencyMark}
        dataLocale={dataLocale}
        delivered={hasDelivered}
        deliveryDate={deliveryDate}
        history={history}
        isReturnCancelled={isReturnCancelled}
        item={item}
        itemId={id}
        localeInfo={localeInfo}
        order={orderData}
        orderData={orderData}
        orderId={orderId}
        orderStatusRedis={orderStatusRedis}
        productId={productId}
        returnConfig={returnConfig}
        returnEligibilityItemDetails={returnEligibilityItemDetails}
        returnId={returnId}
        showItemExchangeRefund={showItemExchangeRefund}
        view="desktop"
      />
      {eligibleForReorder && item.productUrl && (
        <ReOrder
          dataLocale={dataLocale}
          item={item}
          localeInfo={localeInfo}
          userInfo={userInfo}
          view="desktop"
        />
      )}
      {powerRequired === 'POWER_SUBMITTED' && prescriptionView && prescriptionView?.showPd && (
        <AddPdText
          dataLocale={dataLocale}
          isOnlyPd={isOnlyPd}
          listing={listing}
          setSheet={setSheet}
          userInfo={userInfo}
        />
      )}
      {isOnlyPd && (
        <div className="only-pd-modal-wrapper">
          <LKModal
            backdrop
            keyboard
            activeProductData={item}
            dialogClassName="myOrder-powerUpload"
            showModal={isOnlyPd}
            size="lg"
          >
            <Fragment>
              <SuccessModalHeader activeProductData={item} hideHandler={() => setSheet(false)} />
              <AddPD
                dataLocale={dataLocale}
                hideHandler={() => setSheet(false)}
                history={history}
                order={orderData}
                selectedProduct={item}
                updateOrder={() => updateOrder(getOrders, showPowerOptionsFn, match, getOrder)}
                userInfo={userInfoForPd}
              />
            </Fragment>
          </LKModal>
        </div>
      )}
      {canUpdatePrescription &&
        powerRequired === 'POWER_REQUIRED' &&
        localeInfo?.countryCode?.toLowerCase() !== 'sg' &&
        !(redisCommonData?.STUDIO_FLOW_WEB && orderData?.studioFlow) &&
        !orderData?.isInsuranceFlow &&
        !orderData?.studioFlow && (
          <AddPower
            btnText={dataLocale.ADD_POWER}
            listing={listing}
            showPowerOptions={showPowerOptions}
            showPowerOptionsFn={showPowerOptionsFn}
            title={dataLocale.SUBMIT_POWER_TO_COMPLETE_ORDER}
            view="desktop"
          />
        )}
      {localeInfo?.countryCode?.toLowerCase() === 'sg' &&
        !orderData?.studioFlow &&
        canUpdatePrescription &&
        powerRequired === 'POWER_REQUIRED' &&
        !(redisCommonData?.STUDIO_FLOW_WEB && orderData?.studioFlow) &&
        !orderData?.isInsuranceFlow &&
        !orderData?.studioFlow && (
          <AddPower
            btnText={dataLocale.ADD_POWER}
            listing={listing}
            showPowerOptions={showPowerOptions}
            showPowerOptionsFn={showPowerOptionsFn}
            title={dataLocale.SUBMIT_POWER_TO_COMPLETE_ORDER}
            view="desktop"
          />
        )}
      {showPowerOptions && (
        <UpdatePower
          history={history}
          item={item}
          match={match}
          orderData={orderData}
          showPowerOptionsFn={showPowerOptionsFn}
        />
      )}
      {powerRequired === 'POWER_SUBMITTED' && prescriptionView && showPower && (
        <PowerDetails
          dataLocale={dataLocale}
          prescription={prescriptionView}
          showPowerDetailsFn={showPowerDetailsFn}
          showUploadPrescModal={showUploadPrescModal}
          view="desktop"
        />
      )}

      {!listing && showTrackingHistory && (
        <TrackingTimeline
          dataLocale={dataLocale}
          deliveryDate={deliveryDate}
          itemId={id}
          itemTracking={itemTracking}
          orderId={orderId}
          revisedEta={revisedEta}
        />
      )}
      {showPrescription && (
        <LKModal
          keyboard
          dialogClassName="myOrder-showUploadedPower"
          hideHandler={showUploadPrescModal}
          showModal={showPrescription}
          size="lg"
        >
          <div>
            <button
              aria-label="Close Modal Icon"
              className="close"
              type="button"
              onClick={showUploadPrescModal}
            >
              <span>×</span>
            </button>
          </div>
          <img
            alt={dataLocale.UPLOAD_IMG_ALT}
            src={`${config.apiPath.downloadUploadedPrescription}${prescriptionView.imageFileName}`}
            style={{ maxWidth: '50%' }}
          />
        </LKModal>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  return {
    returnConfig: state.myAccount.returnConfig,
    redisCommonData: state.common.redisCommonData,
    currencyMark: state.common.currencyMark,
    localeInfo: state.common.localeInfo,
    userInfoForPd: state.common.userInfo?.result || state.common.userInfo,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    resetState: () => dispatch(resetState()),
    getOrders: (pageName, size) => dispatch(getOrders(pageName, size)),
    getOrder: data => dispatch(getOrder(data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);
